import React from 'react';
import * as constantsViewer from './constants';
import { a } from 'react-spring/three';

export function createReactThreeGeometry(data) {
  return (
    <bufferGeometry attach="geometry">
      <bufferAttribute
        attachObject={['attributes', 'position']}
        count={data.vertices.length / 3}
        array={data.vertices}
        itemSize={3}
      />
      <bufferAttribute
        attachObject={['attributes', 'normal']}
        count={data.normals.length / 3}
        array={data.normals}
        itemSize={3}
      />
      {data.uv_coord ? (
        <bufferAttribute
          attachObject={['attributes', 'uv']}
          count={data.uv_coord.length / 2}
          array={data.uv_coord}
          itemSize={2}
        />
      ) : null}
    </bufferGeometry>
  );
}

export function createReactThreeMaterial(data, unselected, spring) {
  const {
    texture,
    color,
    specular,
    shininess,
    opacity,
    isCorner,
    isUpperShelf = false,
  } = data;
  let opacityValue = 0;

  if (unselected) {
    if (isCorner || isUpperShelf)
      opacityValue = constantsViewer.OPACITY_UNSELECTED_CORNER;
    else opacityValue = constantsViewer.OPACITY_UNSELECTED_SHELF;
  } else if (spring) opacityValue = spring.opacity;
  else opacityValue = opacity;

  return texture ? (
    <a.meshPhongMaterial
      attach="material"
      color={color}
      specular={specular}
      shininess={shininess}
      depthWrite={true}
      opacity={opacityValue}
      transparent
      map={texture}
      onUpdate={self => (self.needsUpdate = true)}
    />
  ) : (
    <a.meshPhongMaterial
      attach="material"
      color={color}
      specular={specular}
      shininess={shininess}
      depthWrite={true}
      opacity={opacityValue}
      transparent
    />
  );
}
